import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

type QuantitySelectorProps = {
  value: number;
  min?: number;
  max?: number;
  onChange: (newValue: number) => void;
  align?: "left" | "center" | "right";
  disabled?: boolean;
};

const QuantitySelector = ({
  value,
  min = 1,
  max = 200,
  onChange,
  align = "center",
  disabled = false
}: QuantitySelectorProps) => {
  const decrease = () => {
    if (!disabled && value > min) {
      onChange(value - 1);
    }
  };

  const increase = () => {
    if (!disabled && value < max) {
      onChange(value + 1);
    }
  };

  const justifyClass =
    align === "left"
      ? "justify-start"
      : align === "right"
      ? "justify-end"
      : "justify-center";

  const arrowClass = disabled
    ? "text-gray-400 cursor-not-allowed"
    : "text-primary-600 cursor-pointer";

  return (
    <div className={`flex items-center ${justifyClass} gap-4 select-none`}>
      <FaChevronLeft
        className={arrowClass}
        size={10} 
        onClick={(e) => {
          if (disabled) {
            return;
          }
          e.stopPropagation();
          decrease();
        }}
      />

      <span className={`text-lg font-bold ${disabled ? "text-gray-400" : ""}`}>
        {value}
      </span>

      <FaChevronRight 
        className={arrowClass}
        size={10} 
        onClick={(e) => {
          if (disabled) {
            return;
          }
          e.stopPropagation();
          increase();
        }}
      />
    </div>
  );
};

export default QuantitySelector;
